import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    NavigationExtras,
    PRIMARY_OUTLET,
    UrlSegmentGroup,
    UrlSegment,
    UrlTree,
} from '@angular/router';

import { Observable } from 'rxjs';

import { Config } from '../config';
import { isPlatformServer } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class RegLangGuard implements CanActivate {
    platformId = inject(PLATFORM_ID);
    constructor(private router: Router, private config: Config) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        const stateUrl: UrlTree = this.router.parseUrl(state.url);
        const regLangPrefix: string = this.config.getLanguageRoutePrefix();
        const queryParams: {} = stateUrl.queryParams;
        const segmentGroup: UrlSegmentGroup =
            stateUrl.root.children[PRIMARY_OUTLET];

        if (isPlatformServer(this.platformId)) {
            return true;
        }

        const segment: UrlSegment[] = segmentGroup ? segmentGroup.segments : [];
        const path: string[] = segment.map((element: any) => element.path);

        //if the next url doesn't contain region and lanuage (w/o leading slash), add them and navigate
        if (!path.includes(this.config.language)) {
            const newUrl: string = [regLangPrefix, ...path].join('/');
            const navigationExtras: NavigationExtras = {
                queryParams: queryParams,
            };

            return this.router.createUrlTree([newUrl], navigationExtras);
        }

        if (!!path[0].match('(^[A-Za-z]{2}$)')) {
            path.shift();
            const newUrl = path.join('/');
            const navigationExtras: NavigationExtras = {
                queryParams: queryParams,
            };

            return this.router.createUrlTree([newUrl], navigationExtras);
        }

        return true;
    }
}
